import { makeStyles } from '@mui/styles';
import { COLOR_PURPLE } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  title: {
    color: COLOR_PURPLE,
    fontSize: 18,
    textAlign: 'center',
    lineHeight: 1.2,
  },
  mainBoxImages: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '14px',
    paddingBottom: theme.spacing(3),
  },
}));
